import { useEffect, useState } from "react";
import {
  IStepOptionDropdownItem,
  StepInstrumentType,
  StepOptionOrderType,
} from "../../Interfaces/stepInterfaces";
import StaticDropdown from "./StaticDropdown";
import CustomStaticDropdown from "./CustomDropdown/CustomStaticDropdown";
import { DropdownProps } from "../../Interfaces/dropdownInterfaces";

interface IProps {
  insInfo: DropdownProps;
  typeInfo: DropdownProps;
  onInsChange: (
    name: string,
    value: any,
    contractSize: number,
    name2?: string,
    value2?: any,
  ) => void;
  onTypeChange: (name: string, value: any) => void;
  insValue?: string;
  typeValue?: StepOptionOrderType;
  instrumentOptions: IStepOptionDropdownItem[];
  extraLabel?: boolean;
}

const InsWithTypeDropdown = ({
  onInsChange,
  onTypeChange,
  insInfo,
  typeInfo,
  typeValue,
  insValue,
  instrumentOptions,
  extraLabel,
}: IProps) => {
  const [instrument, setInstrument] = useState<IStepOptionDropdownItem | null>(
    null,
  );

  useEffect(() => {
    if (!insValue) {
      setInstrument(null);
      return;
    }
    const target = instrumentOptions.find((ins) => ins.id === insValue);
    if (!target) return;
    setInstrument(target);
    // onInsChange(
    //   insInfo.name,
    //   target.id,
    //   target?.contractSize || 0,
    //   typeInfo.name,
    //   target.type
    // );
  }, [insValue, instrumentOptions]);

  const instrumentChangeHandler = (
    name: string,
    value: IStepOptionDropdownItem | null,
  ) => {
    onInsChange(name, value?.id, value?.contractSize || 0, typeInfo.name, null);
    setInstrument(value);
  };

  const optionsOrderTypes = [
    {
      id: StepOptionOrderType.Offset,
      name: "Offset",
    },
    {
      id: StepOptionOrderType.Open,
      name: "Open",
    },
  ];

  return (
    <div className="w-full flex flex-col justify-start items-start gap-3">
      <CustomStaticDropdown
        dropdown={{
          ...insInfo,
          extraLabel,
        }}
        value={instrument}
        onChange={(name, value) => instrumentChangeHandler(name, value)}
        options={instrumentOptions}
        // sendOptionsOnValueChange={handleSellInsType}
      />
      {instrument?.type === StepInstrumentType.Option ? (
        <StaticDropdown
          dropdown={{
            ...typeInfo,
            extraLabel,
          }}
          onChange={onTypeChange}
          options={optionsOrderTypes}
          value={typeValue}
        />
      ) : (
        <></>
      )}
    </div>
  );
};

export default InsWithTypeDropdown;
